<template>
  <span
    :class="currentSizeClasse"
    class="select-none inline-flex items-center justify-center"
    v-html="icons[ligature]"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { icons, type IconName } from '@/icons'
type Sizes = '8' | '12' | '16' | '20' | '24' | '25' | '33' | '36' | '64' | '72'
const { size = '20', ligature } = defineProps<{
  ligature: IconName
  size?: Sizes
}>()

const sizeMap: { [key in Sizes]: string } = {
  '8': 'min-w-[8px] min-h-[8px] max-w-[8px] max-h-[8px]',
  '12': 'min-w-3 min-h-3 max-w-3 max-h-3',
  '16': 'min-w-4 min-h-4 max-w-4 max-h-4',
  '20': 'min-w-5 min-h-5 max-w-5 max-h-5',
  '24': 'min-w-6 min-h-6 max-w-6 max-h-6',
  '25': 'min-w-6.25 min-h-6.25 max-w-6.25 max-h-6.25',
  '33': 'min-w-8 min-h-8 max-w-8 max-h-8',
  '36': 'min-w-9 min-h-9 max-w-9 max-h-9',
  '64': 'min-w-16 min-h-16 max-w-16 max-h-16',
  '72': 'min-w-18 min-h-18 max-w-18 max-h-18',
}
const currentSizeClasse = computed(() => sizeMap[size] || sizeMap['20'])
</script>
